import {
    WAIT_INIT_SETTINGS,

    // profile page
    GET_SETTING_PROFILE_LIST,
    GET_SETTING_PROFILE_LIST_SUCCESS,
    GET_SETTING_PROFILE_LIST_FAIL,
    SELECT_SETTING_PROFILE,
    DELETE_SETTING_PROFILE,
    DELETE_SETTING_PROFILE_SUCCESS,
    DELETE_SETTING_PROFILE_FAIL,
    GET_SETTING_PROFILE_NET,
    GET_SETTING_PROFILE_NET_SUCCESS,
    GET_SETTING_PROFILE_NET_FAIL,
    GET_SETTING_PROFILE_RADIO,
    GET_SETTING_PROFILE_RADIO_SUCCESS,
    GET_SETTING_PROFILE_RADIO_FAIL,
    GET_SETTING_PROFILE_VAP,
    GET_SETTING_PROFILE_VAP_SUCCESS,
    GET_SETTING_PROFILE_VAP_FAIL,
    SAVE_SETTING_PROFILE_NET,
    SAVE_SETTING_PROFILE_NET_SUCCESS,
    SAVE_SETTING_PROFILE_NET_FAIL,
    SAVE_SETTING_PROFILE_RADIO,
    SAVE_SETTING_PROFILE_RADIO_SUCCESS,
    SAVE_SETTING_PROFILE_RADIO_FAIL,
    SAVE_SETTING_PROFILE_VAP,
    SAVE_SETTING_PROFILE_VAP_SUCCESS,
    SAVE_SETTING_PROFILE_VAP_FAIL,

    // account page
    SAVE_SETTING_ACCOUNT_APPLY,
    SAVE_SETTING_ACCOUNT_APPLY_SUCCESS,
    SAVE_SETTING_ACCOUNT_APPLY_FAIL,
    GET_SETTING_ACCOUNT_APPLY_LIST,
    GET_SETTING_ACCOUNT_APPLY_LIST_SUCCESS,
    GET_SETTING_ACCOUNT_APPLY_LIST_FAIL,
    SELECT_SETTING_ACCOUNT,
    DELETE_SETTING_ACCOUNT,
    DELETE_SETTING_ACCOUNT_SUCCESS,
    DELETE_SETTING_ACCOUNT_FAIL,
    GET_SETTING_ACCOUNT_DETAIL,
    GET_SETTING_ACCOUNT_DETAIL_SUCCESS,
    GET_SETTING_ACCOUNT_DETAIL_FAIL,
    SAVE_SETTING_ACCOUNT_DETAIL,
    SAVE_SETTING_ACCOUNT_DETAIL_SUCCESS,
    SAVE_SETTING_ACCOUNT_DETAIL_FAIL,
    CONFIRM_SETTING_ACCOUNT_APPLY,
    CONFIRM_SETTING_ACCOUNT_APPLY_SUCCESS,
    CONFIRM_SETTING_ACCOUNT_APPLY_FAIL,
    LOAD_SETTING_ACCOUNT_LIST,

    // account Opearation status
    GET_ACCOUNT_OPERATION_STATUS_SUCCESS,
    SAVE_ACCOUNT_OPERATION_STATUS_IN_FRONT_END,

    //  role page
    SELECT_SETTING_ROLE,
    DELETE_SETTING_ROLE,
    DELETE_SETTING_ROLE_SUCCESS,
    DELETE_SETTING_ROLE_FAIL,
    GET_SETTING_ROLE_DETAIL,
    GET_SETTING_ROLE_DETAIL_SUCCESS,
    GET_SETTING_ROLE_DETAIL_FAIL,
    SAVE_SETTING_ROLE_DETAIL,
    SAVE_SETTING_ROLE_DETAIL_SUCCESS,
    SAVE_SETTING_ROLE_DETAIL_FAIL,

    // notification
    GET_NOTIFICATION_SETTING,
    GET_NOTIFICATION_SETTING_SUCCESS,
    GET_NOTIFICATION_SETTING_FAIL,
    SAVE_NOTIFICATION_SETTING,
    SAVE_NOTIFICATION_SETTING_SUCCESS,
    SAVE_NOTIFICATION_SETTING_FAIL,
    TEST_SMTP_EMAIL,
    TEST_SMTP_EMAIL_SUCCESS,
    TEST_SMTP_EMAIL_FAIL,

    // network
    GET_NETWORK_SETTING,
    GET_NETWORK_SETTING_SUCCESS,
    GET_NETWORK_SETTING_FAIL,
    SAVE_NETWORK_SETTING,
    SAVE_NETWORK_SETTING_SUCCESS,
    SAVE_NETWORK_SETTING_FAIL,

    // initail setup
    SAVE_INITIAL_SETUP,
    SAVE_INITIAL_SETUP_SUCCESS,
    SAVE_INITIAL_SETUP_FAIL,

    // about
    GET_SETTING_ABOUT_SUCCESS,
    GET_SETTING_ABOUT_FAIL,
    PRISMX_LOCAL_UPGRADE_SUCCESS,
    PRISMX_LOCAL_UPGRADE_FAIL,
    PRISMX_LOCAL_UPGRADE_INIT,
    SAVE_SYSTEM_DATE,
    SAVE_SYSTEM_DATE_SUCCESS,
    SAVE_SYSTEM_DATE_FAIL,

    GET_GUEST_PORTAL_SETTINGS_DETAIL_SUCCESS,
    DELETE_GUEST_PORTAL_SETTINGS,
    DELETE_GUEST_PORTAL_SETTINGS_SUCCESS,
    DELETE_GUEST_PORTAL_SETTINGS_FAIL,


    // wifi
    GET_GLOBAL_AP_SETTING,
    GET_GLOBAL_AP_SETTING_SUCCESS,
    GET_GLOBAL_AP_SETTING_FAIL,
    SAVE_GLOBAL_AP_SETTING,
    SAVE_GLOBAL_AP_SETTING_SUCCESS,
    SAVE_GLOBAL_AP_SETTING_FAIL,
    GET_WIFI_SETTINGS_DETAIL_SUCCESS,
    GET_WIFI_SETTINGS_DETAIL_FAIL,
    GET_GROUP_AP_SETTINGS_DETAIL_SUCCESS,
    DELETE_GROUP_AP_SETTINGS_DATA,
    DELETE_GROUP_AP_SETTINGS_DATA_SUCCESS,
    DELETE_GROUP_AP_SETTINGS_DATA_FAIL,
    SELECT_NETWORK_ZONE_DETAIL,
    SET_WIFI_LIST,
    DELETE_WIFI_SETTINGS,
    DELETE_WIFI_SETTINGS_SUCCESS,
    DELETE_WIFI_SETTINGS_FAIL,
    // GET_DEVICE_MAC_WHITE_LIST,
    // GET_DEVICE_MAC_WHITE_LIST_SUCCESS,
    // GET_DEVICE_MAC_WHITE_LIST_FAIL,
    // UPDATE_DEVICE_MAC_WHITE_LIST,
    // UPDATE_DEVICE_MAC_WHITE_LIST_SUCCESS,
    // UPDATE_DEVICE_MAC_WHITE_LIST_FAIL,
    GET_GROUP_DEVICES,
    GET_GROUP_DEVICES_SUCCESS,
    GET_GROUP_DEVICES_FAIL,
    DELETE_NETWORK_ZONE,
    DELETE_NETWORK_ZONE_SUCCESS,
    DELETE_NETWORK_ZONE_FAIL,
    SAVE_NETWORK_ZONE_DATA,
    SAVE_NETWORK_ZONE_DATA_SUCCESS,
    SAVE_NETWORK_ZONE_DATA_FAIL,
    SAVE_WIFI_SETTINGS_DATA,
    SAVE_WIFI_SETTINGS_DATA_SUCCESS,
    SAVE_WIFI_SETTINGS_DATA_FAIL,
    SYNC_WIFI_SETTING,
    SYNC_WIFI_SETTING_SUCCESS,
    SYNC_WIFI_SETTING_FAIL, 
    SAVE_NETWORK_ZONE_IMPORT_FILE_FAIL,
    GET_AP_EXCLUSION_SETTINGS_DETAIL_SUCCESS,
    SAVE_AP_EXCLUSION_DATA_SUCCESS,
    SAVE_AP_EXCLUSION_DATA_FAIL,
    SAVE_AP_EXCLUSION_DATA
    
} from "../actions/settings/index";

const doAction = (state, action) => {  
    switch (action.type) {

    // profile
    case GET_SETTING_PROFILE_LIST:
        return {
            ...state,
            status: GET_SETTING_PROFILE_LIST,
            profileList: null,
            loading: true
        }
    case GET_SETTING_PROFILE_LIST_SUCCESS:
        return {
            ...state,
            status: GET_SETTING_PROFILE_LIST_SUCCESS,
            profileList: action.params.profileList,
            loading: false
        }
    case GET_SETTING_PROFILE_LIST_FAIL:
        return {
            ...state,
            status: GET_SETTING_PROFILE_LIST_FAIL,
            loading: false
        }
    case SELECT_SETTING_PROFILE:
        return {
            ...state,
            status: SELECT_SETTING_PROFILE,
            selectProfile: action.params.selectProfile,
            saveProfileId: null,
        }
    case DELETE_SETTING_PROFILE:
        return {
            ...state,
            status: DELETE_SETTING_PROFILE,
            loading: true,
            errMsg: null
        }
    case DELETE_SETTING_PROFILE_SUCCESS:
        return {
            ...state,
            status: DELETE_SETTING_PROFILE_SUCCESS,
            loading: false
        }
    case DELETE_SETTING_PROFILE_FAIL:
        return {
            ...state,
            status: DELETE_SETTING_PROFILE_FAIL,
            loading: false,
            errMsg: action.params.errMsg
        }
    case GET_SETTING_PROFILE_NET:
        return {
            ...state,
            status: GET_SETTING_PROFILE_NET,
            profileNetList: null,
            loading: true
        }
    case GET_SETTING_PROFILE_NET_SUCCESS:
        return {
            ...state,
            status: GET_SETTING_PROFILE_NET_SUCCESS,
            profileNetList: action.params.profileNetList,
            loading: false
        }
    case GET_SETTING_PROFILE_NET_FAIL:
        return {
            ...state,
            status: GET_SETTING_PROFILE_NET_FAIL,
            loading: false
        }
    case GET_SETTING_PROFILE_RADIO:
        return {
            ...state,
            status: GET_SETTING_PROFILE_RADIO,
            profileRadioList: null,
            loading: true
        }
    case GET_SETTING_PROFILE_RADIO_SUCCESS:
        return {
            ...state,
            status: GET_SETTING_PROFILE_RADIO_SUCCESS,
            profileRadioList: action.params.profileRadioList,
            loading: false
        }
    case GET_SETTING_PROFILE_RADIO_FAIL:
        return {
            ...state,
            status: GET_SETTING_PROFILE_RADIO_FAIL,
            loading: false
        }
    case GET_SETTING_PROFILE_VAP:
        return {
            ...state,
            status: GET_SETTING_PROFILE_VAP,
            profileVapList: null,
            loading: true
        }
    case GET_SETTING_PROFILE_VAP_SUCCESS:
        return {
            ...state,
            status: GET_SETTING_PROFILE_VAP_SUCCESS,
            profileVapList: action.params.profileVapList,
            loading: false
        }
    case GET_SETTING_PROFILE_VAP_FAIL:
        return {
            ...state,
            status: GET_SETTING_PROFILE_VAP_FAIL,
            loading: false
        }
    case SAVE_SETTING_PROFILE_NET:
        return {
            ...state,
            status: SAVE_SETTING_PROFILE_NET,
            loading: true
        }
    case SAVE_SETTING_PROFILE_NET_SUCCESS:
        return {
            ...state,
            status: SAVE_SETTING_PROFILE_NET_SUCCESS,
            saveProfileId: action.params.saveProfileId,
            loading: false
        }
    case SAVE_SETTING_PROFILE_NET_FAIL:
        return {
            ...state,
            status: SAVE_SETTING_PROFILE_NET_FAIL,
            loading: false,
            errMsg: action.params.errMsg
        }
    case SAVE_SETTING_PROFILE_RADIO:
        return {
            ...state,
            status: SAVE_SETTING_PROFILE_RADIO,
            loading: true
        }
    case SAVE_SETTING_PROFILE_RADIO_SUCCESS:
        return {
            ...state,
            status: SAVE_SETTING_PROFILE_RADIO_SUCCESS,
            saveProfileId: action.params.saveProfileId,
            loading: false
        }
    case SAVE_SETTING_PROFILE_RADIO_FAIL:
        return {
            ...state,
            status: SAVE_SETTING_PROFILE_RADIO_FAIL,
            loading: false,
            errMsg: action.params.errMsg
        }
    case SAVE_SETTING_PROFILE_VAP:
        return {
            ...state,
            status: SAVE_SETTING_PROFILE_VAP,
            loading: true
        }
    case SAVE_SETTING_PROFILE_VAP_SUCCESS:
        return {
            ...state,
            status: SAVE_SETTING_PROFILE_VAP_SUCCESS,
            saveProfileId: action.params.saveProfileId,
            loading: false
        }
    case SAVE_SETTING_PROFILE_VAP_FAIL:
        return {
            ...state,
            status: SAVE_SETTING_PROFILE_VAP_FAIL,
            loading: false,
            errMsg: action.params.errMsg
        }
    
    // account & role
    case SAVE_SETTING_ACCOUNT_APPLY:
        return {
            ...state,
            status: SAVE_SETTING_ACCOUNT_APPLY,
            loading: true
        }
    case SAVE_SETTING_ACCOUNT_APPLY_SUCCESS:
        return {
            ...state,
            status: SAVE_SETTING_ACCOUNT_APPLY_SUCCESS,
            loading: false
        }
    case SAVE_SETTING_ACCOUNT_APPLY_FAIL:
        return {
            ...state,
            status: SAVE_SETTING_ACCOUNT_APPLY_FAIL,
            loading: false,
            errMsg: action.params.errMsg
        }
    case GET_SETTING_ACCOUNT_APPLY_LIST:
        return {
            ...state,
            status: GET_SETTING_ACCOUNT_APPLY_LIST,
            accountApplyList: null,
            loading: true
        }
    case GET_SETTING_ACCOUNT_APPLY_LIST_SUCCESS:
        return {
            ...state,
            status: GET_SETTING_ACCOUNT_APPLY_LIST_SUCCESS,
            accountApplyList: action.params.accountApplyList,
            loading: false
        }
    case GET_SETTING_ACCOUNT_APPLY_LIST_FAIL:
        return {
            ...state,
            status: GET_SETTING_ACCOUNT_APPLY_LIST_FAIL,
            loading: false,
            errMsg: action.params.errMsg
        }
    case CONFIRM_SETTING_ACCOUNT_APPLY:
        return {
            ...state,
            status: CONFIRM_SETTING_ACCOUNT_APPLY,
            loading: true
        }
    case CONFIRM_SETTING_ACCOUNT_APPLY_SUCCESS:
        return {
            ...state,
            status: CONFIRM_SETTING_ACCOUNT_APPLY_SUCCESS,
            loading: false
        }
    case CONFIRM_SETTING_ACCOUNT_APPLY_FAIL:
        return {
            ...state,
            status: CONFIRM_SETTING_ACCOUNT_APPLY_FAIL,
            loading: false,
            errMsg: action.params.errMsg
        }

    // account
    case SELECT_SETTING_ACCOUNT:
        return {
            ...state,
            status: SELECT_SETTING_ACCOUNT,
            selectAccount: action.params.selectAccount
        }
    case DELETE_SETTING_ACCOUNT:
        return {
            ...state,
            status: DELETE_SETTING_ACCOUNT,
            loading: true,
            errMsg: null
        }
    case DELETE_SETTING_ACCOUNT_SUCCESS:
        return {
            ...state,
            status: DELETE_SETTING_ACCOUNT_SUCCESS,
            loading: false
        }
    case DELETE_SETTING_ACCOUNT_FAIL:
        return {
            ...state,
            status: DELETE_SETTING_ACCOUNT_FAIL,
            loading: false,
            errMsg: action.params.errMsg
        }
    case GET_SETTING_ACCOUNT_DETAIL:
        return {
            ...state,
            status: GET_SETTING_ACCOUNT_DETAIL,
            accountDetail: null,
            loading: true
        }
    case GET_SETTING_ACCOUNT_DETAIL_SUCCESS:
        return {
            ...state,
            status: GET_SETTING_ACCOUNT_DETAIL_SUCCESS,
            accountDetail: action.params.accountDetail,
            loading: false
        }
    case GET_SETTING_ACCOUNT_DETAIL_FAIL:
        return {
            ...state,
            status: GET_SETTING_ACCOUNT_DETAIL_FAIL,
            loading: false
        }
    case SAVE_SETTING_ACCOUNT_DETAIL:
        return {
            ...state,
            status: SAVE_SETTING_ACCOUNT_DETAIL,
            loading: true
        }
    case SAVE_SETTING_ACCOUNT_DETAIL_SUCCESS:
        return {
            ...state,
            status: SAVE_SETTING_ACCOUNT_DETAIL_SUCCESS,
            loading: false
        }
    case SAVE_SETTING_ACCOUNT_DETAIL_FAIL:
        return {
            ...state,
            status: SAVE_SETTING_ACCOUNT_DETAIL_FAIL,
            loading: false,
            errMsg: action.params.errMsg
        }
    case LOAD_SETTING_ACCOUNT_LIST:
        return {
            ...state,
            errMsg: null,
            status: LOAD_SETTING_ACCOUNT_LIST,
            accountData: action.params.accountData
        }

    // account operation status
    case GET_ACCOUNT_OPERATION_STATUS_SUCCESS:
        return{
          ...state,
          type: GET_ACCOUNT_OPERATION_STATUS_SUCCESS ,
        //   accountOperationStatusList: {hehe : true, haha: true}
        accountOperationStatusList: action.params.accountOperationStatusList
        }

    // account operation status
    case SAVE_ACCOUNT_OPERATION_STATUS_IN_FRONT_END:
        return{
        //   ...state,
          type: SAVE_ACCOUNT_OPERATION_STATUS_IN_FRONT_END ,
        //   accountOperationStatusList: {hehe : true, haha: true}
        accountOperationStatusList: action.params.accountOperationStatusList
        }


    // role
    case SELECT_SETTING_ROLE:
        return {
            ...state,
            status: SELECT_SETTING_ROLE,
            selectRole: action.params.selectRole
        }
    case DELETE_SETTING_ROLE:
        return {
            ...state,
            status: DELETE_SETTING_ROLE,
            loading: true,
            errMsg: null
        }
    case DELETE_SETTING_ROLE_SUCCESS:
        return {
            ...state,
            status: DELETE_SETTING_ROLE_SUCCESS,
            loading: false
        }
    case DELETE_SETTING_ROLE_FAIL:
        return {
            ...state,
            status: DELETE_SETTING_ROLE_FAIL,
            loading: false,
            errMsg: action.params.errMsg
        }
    case GET_SETTING_ROLE_DETAIL:
        return {
            ...state,
            status: GET_SETTING_ROLE_DETAIL,
            roleDetail: null,
            loading: true
        }
    case GET_SETTING_ROLE_DETAIL_SUCCESS:
        return {
            ...state,
            status: GET_SETTING_ROLE_DETAIL_SUCCESS,
            roleDetail: action.params.roleDetail,
            loading: false
        }
    case GET_SETTING_ROLE_DETAIL_FAIL:
        return {
            ...state,
            status: GET_SETTING_ROLE_DETAIL_FAIL,
            loading: false
        }
    case SAVE_SETTING_ROLE_DETAIL:
        return {
            ...state,
            status: SAVE_SETTING_ROLE_DETAIL,
            loading: true
        }
    case SAVE_SETTING_ROLE_DETAIL_SUCCESS:
        return {
            ...state,
            status: SAVE_SETTING_ROLE_DETAIL_SUCCESS,
            loading: false
        }
    case SAVE_SETTING_ROLE_DETAIL_FAIL:
        return {
            ...state,
            status: SAVE_SETTING_ROLE_DETAIL_FAIL,
            loading: false,
            errMsg: action.params.errMsg
        }
    
    // notification
    case GET_NOTIFICATION_SETTING:
        return {
            ...state,
            status: GET_NOTIFICATION_SETTING,
            notifyDetail: null,
            loading: true
        }
    case GET_NOTIFICATION_SETTING_SUCCESS:
        return {
            ...state,
            status: GET_NOTIFICATION_SETTING_SUCCESS,
            notifyDetail: action.params.notifyDetail,
            loading: false
        }
    case GET_NOTIFICATION_SETTING_FAIL:
        return {
            ...state,
            status: GET_NOTIFICATION_SETTING_FAIL,
            notifyDetail: null,
            loading: false
        }
    case SAVE_NOTIFICATION_SETTING:
        return {
            ...state,
            status: SAVE_NOTIFICATION_SETTING,
            loading: true
        }
    case SAVE_NOTIFICATION_SETTING_SUCCESS:
        return {
            ...state,
            status: SAVE_NOTIFICATION_SETTING_SUCCESS,
            loading: false
        }
    case SAVE_NOTIFICATION_SETTING_FAIL:
        return {
            ...state,
            status: SAVE_NOTIFICATION_SETTING_FAIL,
            loading: false,
            errMsg: action.params.errMsg
        }
    case TEST_SMTP_EMAIL:
        return {
            ...state,
            status: TEST_SMTP_EMAIL,
            loading: true
        }
    case TEST_SMTP_EMAIL_SUCCESS:
        return {
            ...state,
            status: TEST_SMTP_EMAIL_SUCCESS,
            loading: false
        }
    case TEST_SMTP_EMAIL_FAIL:
        return {
            ...state,
            status: TEST_SMTP_EMAIL_FAIL,
            loading: false,
            errMsg: action.params.errMsg
        }
    
    // network
    case GET_NETWORK_SETTING:
        return {
            ...state,
            status: GET_NETWORK_SETTING,
            networkDetail: null,
            loading: true
        }
    case GET_NETWORK_SETTING_SUCCESS:
        return {
            ...state,
            status: GET_NETWORK_SETTING_SUCCESS,
            networkDetail: action.params.networkDetail,
            loading: false
        }
    case GET_NETWORK_SETTING_FAIL:
        return {
            ...state,
            status: GET_NETWORK_SETTING_FAIL,
            networkDetail: null,
            loading: false
        }
    case SAVE_NETWORK_SETTING:
        return {
            ...state,
            status: SAVE_NETWORK_SETTING,
            loading: true
        }
    case SAVE_NETWORK_SETTING_SUCCESS:
        return {
            ...state,
            status: SAVE_NETWORK_SETTING_SUCCESS,
            loading: false
        }
    case SAVE_NETWORK_SETTING_FAIL:
        return {
            ...state,
            status: SAVE_NETWORK_SETTING_FAIL,
            loading: false,
            errMsg: action.params.errMsg
        }
    case SAVE_INITIAL_SETUP:
        return{
            ...state,
            status: SAVE_INITIAL_SETUP,
            loading: true
        }
    case SAVE_INITIAL_SETUP_SUCCESS:
        return{
            ...state,
            status: SAVE_INITIAL_SETUP_SUCCESS,
            loading: false
        }
    case SAVE_INITIAL_SETUP_FAIL:
        return{
            ...state,
            status: SAVE_INITIAL_SETUP_FAIL,
            loading: false
        }
    case GET_SETTING_ABOUT_SUCCESS:
        return {
            ...state,
            status: GET_SETTING_ABOUT_SUCCESS,
            systemInfo: action.params.systemInfo,
            mx100Time: action.params.mx100Time,
            systemVersion: action.params.systemVersion,
            modelName: action.params.modelName
        }
    case GET_SETTING_ABOUT_FAIL:
        return {
            ...state,
            status: GET_SETTING_ABOUT_FAIL,
            systemInfo: null,
            errMsg: action.params.errMsg
        }
    case GET_GLOBAL_AP_SETTING:
        return {
            ...state,
            status: GET_GLOBAL_AP_SETTING,
            globalApInfo: null
        }
    case GET_GLOBAL_AP_SETTING_SUCCESS:
        return {
            ...state,
            status: GET_GLOBAL_AP_SETTING_SUCCESS,
            globalApInfo: action.params.globalApInfo
        }
    case GET_GLOBAL_AP_SETTING_FAIL:
        return {
            ...state,
            status: GET_GLOBAL_AP_SETTING_FAIL,
            globalApInfo: null
        }
    case SAVE_GLOBAL_AP_SETTING:
        return {
            ...state,
            status: SAVE_GLOBAL_AP_SETTING
        }
    case SAVE_GLOBAL_AP_SETTING_SUCCESS:
        return {
            ...state,
            status: SAVE_GLOBAL_AP_SETTING_SUCCESS,
            globalApInfo: action.params.globalApInfo
        }
    case SAVE_GLOBAL_AP_SETTING_FAIL:
        return {
            ...state,
            status: SAVE_GLOBAL_AP_SETTING_FAIL,
            globalApInfo: null
        }
    case GET_WIFI_SETTINGS_DETAIL_SUCCESS:
        return {
            ...state,
            status: GET_WIFI_SETTINGS_DETAIL_SUCCESS,
            wifiSettingsDetail: action.params.wifiSettingsDetail,
            modelName: action.params.modelName
        }
    case GET_WIFI_SETTINGS_DETAIL_FAIL:
        return {
            ...state,
            status: GET_WIFI_SETTINGS_DETAIL_FAIL,
            wifiSettingsDetail: null,
            errMsg: action.params.errMsg
        }
    case SELECT_NETWORK_ZONE_DETAIL:
        return {
            ...state,
            status: SELECT_NETWORK_ZONE_DETAIL,
            networkZoneDetail: action.params.networkZoneDetail
        }
    case SET_WIFI_LIST:
        return {
            ...state,
            status: SET_WIFI_LIST,
            settingsWifiList: action.params.settingsWifiList
        }
    case DELETE_WIFI_SETTINGS:
        return {
            ...state,
            status: DELETE_WIFI_SETTINGS,
        }
    case DELETE_WIFI_SETTINGS_SUCCESS:
        return {
            ...state,
            status: DELETE_WIFI_SETTINGS_SUCCESS,
        }
    case DELETE_WIFI_SETTINGS_FAIL:
        return {
            ...state,
            status: DELETE_WIFI_SETTINGS_FAIL,
            errMsg: action.params.errMsg
        }
    // case GET_DEVICE_MAC_WHITE_LIST:
    //     return {
    //         ...state,
    //         status: GET_DEVICE_MAC_WHITE_LIST,
    //         macWhiteList: null
    //     }
    // case GET_DEVICE_MAC_WHITE_LIST_SUCCESS:
    //     return {
    //         ...state,
    //         status: GET_DEVICE_MAC_WHITE_LIST_SUCCESS,
    //         macWhiteList: action.params.macWhiteList
    //     }
    // case GET_DEVICE_MAC_WHITE_LIST_FAIL:
    //     return {
    //         ...state,
    //         status: GET_DEVICE_MAC_WHITE_LIST_FAIL,
    //         errMsg: action.params.errMsg
    //     }
    // case UPDATE_DEVICE_MAC_WHITE_LIST:
    //     return {
    //         ...state,
    //         status: UPDATE_DEVICE_MAC_WHITE_LIST,
    //         macWhiteList: null
    //     }
    // case UPDATE_DEVICE_MAC_WHITE_LIST_SUCCESS:
    //     return {
    //         ...state,
    //         status: UPDATE_DEVICE_MAC_WHITE_LIST_SUCCESS,
    //         macWhiteList: action.params.macWhiteList
    //     }
    // case UPDATE_DEVICE_MAC_WHITE_LIST_FAIL:
    //     return {
    //         ...state,
    //         status: UPDATE_DEVICE_MAC_WHITE_LIST_FAIL,
    //         errMsg: action.params.errMsg
    //     }
    case GET_GROUP_DEVICES:
        return {
            ...state,
            status: GET_GROUP_DEVICES,
            groupDevices: null
        }
    case GET_GROUP_DEVICES_SUCCESS:
        return {
            ...state,
            status: GET_GROUP_DEVICES_SUCCESS,
            groupDevices: action.params.groupDevices
        }
    case GET_GROUP_DEVICES_FAIL:
        return {
            ...state, 
            status: GET_GROUP_DEVICES_FAIL,
            groupDevices: null
        }
    case GET_GROUP_AP_SETTINGS_DETAIL_SUCCESS:
        return {
            ...state,
            staus: GET_GROUP_AP_SETTINGS_DETAIL_SUCCESS,
            groupSettingsDetail: action.params.groupSettingsDetail
        }
    case DELETE_GROUP_AP_SETTINGS_DATA:
        return {
            ...state,
            status: DELETE_GROUP_AP_SETTINGS_DATA
        }
    case DELETE_GROUP_AP_SETTINGS_DATA_SUCCESS:
        return {
            ...state,
            status: DELETE_GROUP_AP_SETTINGS_DATA_SUCCESS
        }
    case DELETE_GROUP_AP_SETTINGS_DATA_FAIL:
        return {
            ...state,
            status: DELETE_GROUP_AP_SETTINGS_DATA_FAIL
        }
    case SYNC_WIFI_SETTING:
        return {
            ...state,
            status: SYNC_WIFI_SETTING
        }
    case SYNC_WIFI_SETTING_SUCCESS:
        return {
            ...state,
            status: SYNC_WIFI_SETTING_SUCCESS
        }
    case SYNC_WIFI_SETTING_FAIL:
        return {
            ...state,
            status: SYNC_WIFI_SETTING_FAIL
        }
    case SAVE_NETWORK_ZONE_DATA:
        return {
            ...state,
            status: SAVE_NETWORK_ZONE_DATA
        }
    case SAVE_NETWORK_ZONE_DATA_SUCCESS:
        return {
            ...state,
            status: SAVE_NETWORK_ZONE_DATA_SUCCESS
        }
    case SAVE_NETWORK_ZONE_DATA_FAIL:
        return {
            ...state,
            status: SAVE_NETWORK_ZONE_DATA_FAIL,
            errMsg: action.params.errMsg
        }
    case SAVE_NETWORK_ZONE_IMPORT_FILE_FAIL:
        return {
            ...state,
            status: SAVE_NETWORK_ZONE_IMPORT_FILE_FAIL,
            errMsg: action.params.errMsg
        }
    case DELETE_NETWORK_ZONE:
        return {
            ...state,
            status: DELETE_NETWORK_ZONE
        }
    case DELETE_NETWORK_ZONE_SUCCESS:
        return {
            ...state,
            status: DELETE_NETWORK_ZONE_SUCCESS
        }
    case DELETE_NETWORK_ZONE_FAIL:
        return {
            ...state,
            status: DELETE_NETWORK_ZONE_FAIL,
            errMsg: action.params.errMsg
        }
    case SAVE_WIFI_SETTINGS_DATA:
        return {
            ...state,
            status: SAVE_WIFI_SETTINGS_DATA
        }
    case SAVE_WIFI_SETTINGS_DATA_SUCCESS:
        return {
            ...state,
            status: SAVE_WIFI_SETTINGS_DATA_SUCCESS
        }
    case SAVE_WIFI_SETTINGS_DATA_FAIL:
        return {
            ...state,
            status: SAVE_WIFI_SETTINGS_DATA_FAIL,
            errMsg: action.params.errMsg
        }
    case GET_GUEST_PORTAL_SETTINGS_DETAIL_SUCCESS:
        return {
            ...state,
            status: GET_GUEST_PORTAL_SETTINGS_DETAIL_SUCCESS,
            guestPortalSettingsDetail: action.params.guestPortalSettingsDetail
        }
    case DELETE_GUEST_PORTAL_SETTINGS:
        return {
            ...state,
            status: DELETE_GUEST_PORTAL_SETTINGS
        }
    case DELETE_GUEST_PORTAL_SETTINGS_SUCCESS:
        return {
            ...state,
            status: DELETE_GUEST_PORTAL_SETTINGS_SUCCESS
       }
    case DELETE_GUEST_PORTAL_SETTINGS_FAIL:
        return {
            ...state,
            status: DELETE_GUEST_PORTAL_SETTINGS_FAIL
       }

    case PRISMX_LOCAL_UPGRADE_INIT:
        return {
            ...state,
            status: PRISMX_LOCAL_UPGRADE_INIT
        }
    case PRISMX_LOCAL_UPGRADE_SUCCESS:
        return {
            ...state,
            status: PRISMX_LOCAL_UPGRADE_SUCCESS
       }
    case PRISMX_LOCAL_UPGRADE_FAIL:
        return {
            ...state,
            status: PRISMX_LOCAL_UPGRADE_FAIL
       }
    case SAVE_SYSTEM_DATE:
        return {
            ...state,
            status: SAVE_SYSTEM_DATE
        } 
    case SAVE_SYSTEM_DATE_SUCCESS:
        return {
            ...state,
            status: SAVE_SYSTEM_DATE_SUCCESS
    } 
    case SAVE_SYSTEM_DATE_FAIL:
        return {
            ...state,
            status: SAVE_SYSTEM_DATE_FAIL
    }
    case GET_AP_EXCLUSION_SETTINGS_DETAIL_SUCCESS:
        return {
            ...state,
            status: GET_AP_EXCLUSION_SETTINGS_DETAIL_SUCCESS,
            apExclusionsData: action.params.apExclusionsData
        }  
    case SAVE_AP_EXCLUSION_DATA:
        return {
            ...state,
            status: SAVE_AP_EXCLUSION_DATA
        } 
    case SAVE_AP_EXCLUSION_DATA_SUCCESS:
        return {
            ...state,
            status: SAVE_AP_EXCLUSION_DATA_SUCCESS
        } 
    case SAVE_AP_EXCLUSION_DATA_FAIL:
        return {
            ...state,
            status: SAVE_AP_EXCLUSION_DATA_FAIL
        } 
    default:
        return state;
    }
}

const settingsReducers = (state = {
    errMsg: null,
    status: WAIT_INIT_SETTINGS,
    loading: false,
    popLoading: false,
    selectAccount: null,
    selectRole: null,
    selectProfile: null,
    profileList: null,
    profileNetList: null,
    profileRadioList: null,
    profileVapList: null,
    accountApplyList: null,
    accountDetail: null,
    accountData: null,
    accountOperationStatusList: null,
    roleDetail: null,
    notifyDetail: null,
    networkDetail: null,
    systemInfo: null,
    globalApInfo: null,
    wifiSettingsDetail: null,
    networkZoneDetail: null,
    guestPortalSettingsDetail: null,
    settingsWifiList: [],
    // macWhiteList:null,
    // isExistInMacWhiteList:null,
    groupDevices: null,
    mx100Time: null,
    groupSettingsDetail: null,
    apExclusionsData: null
  }, action) => {
    switch (action.type) {
      default:
        return doAction(state, action);
    }
  }
  
  export default settingsReducers;